var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("dialogs-base", {
    attrs: { show: _setup.dialog, "max-width": "20%" },
    on: {
      "update:show": function ($event) {
        _setup.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "activator",
        fn: function ({ on, attrs }) {
          return [
            _c(
              "v-text-field",
              _vm._g(
                _vm._b(
                  {
                    attrs: {
                      label: _vm.label,
                      readonly: "",
                      "error-messages": _vm.errorMessages,
                      "hide-details": _vm.errorMessages ? false : true,
                      outlined: _vm.outlined,
                      dense: _vm.dense,
                      disabled: _vm.disabled,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-calendar-today"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _setup.dateFormatted,
                      callback: function ($$v) {
                        _setup.dateFormatted = $$v
                      },
                      expression: "dateFormatted",
                    },
                  },
                  "v-text-field",
                  attrs,
                  false
                ),
                _vm.disabled ? {} : on
              )
            ),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-date-picker",
              {
                attrs: { scrollable: "", readonly: _vm.disabled },
                model: {
                  value: _setup.date,
                  callback: function ($$v) {
                    _setup.date = $$v
                  },
                  expression: "date",
                },
              },
              [
                _c("v-spacer"),
                _c("ButtonsText", {
                  attrs: { label: "Cancelar", color: "error" },
                  on: {
                    click: function ($event) {
                      _setup.dialog = false
                    },
                  },
                }),
                _c("ButtonsText", {
                  attrs: { label: "Confirmar", disabled: _vm.disabled },
                  on: { click: _setup.closeDialog },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }